type GlobalWithCrypto = typeof globalThis & { crypto?: Crypto };

const getCrypto = (): Crypto | undefined => {
  if (typeof globalThis === 'undefined') {
    return undefined;
  }

  const maybeCrypto = (globalThis as GlobalWithCrypto).crypto;
  return typeof maybeCrypto === 'object' ? maybeCrypto : undefined;
};

const createUuidFromBytes = (bytes: Uint8Array): string => {
  // Set version (4) and variant bits to follow UUID v4 format
  const uuidBytes = new Uint8Array(bytes);
  uuidBytes[6] = (uuidBytes[6] & 0x0f) | 0x40;
  uuidBytes[8] = (uuidBytes[8] & 0x3f) | 0x80;

  const hex = Array.from(uuidBytes, (byte) => byte.toString(16).padStart(2, '0'));

  return [
    hex.slice(0, 4).join(''),
    hex.slice(4, 6).join(''),
    hex.slice(6, 8).join(''),
    hex.slice(8, 10).join(''),
    hex.slice(10, 16).join('')
  ].join('-');
};

const createFallbackId = (): string => {
  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).slice(2, 10);
  return `${timestamp}-${random}`;
};

export const generateUniqueId = (prefix?: string): string => {
  const cryptoObj = getCrypto();

  if (cryptoObj?.randomUUID) {
    const uuid = cryptoObj.randomUUID();
    return prefix ? `${prefix}-${uuid}` : uuid;
  }

  if (cryptoObj?.getRandomValues) {
    const bytes = new Uint8Array(16);
    cryptoObj.getRandomValues(bytes);
    const uuidLike = createUuidFromBytes(bytes);
    return prefix ? `${prefix}-${uuidLike}` : uuidLike;
  }

  const fallback = createFallbackId();
  return prefix ? `${prefix}-${fallback}` : fallback;
};
